/* eslint-disable ember/no-computed-properties-in-native-classes */
import { tracked } from '@glimmer/tracking';
import PaperButton from 'ember-paper/components/paper-button';
import { computed } from '@ember/object';

export default class AsyncButton extends PaperButton {
  @tracked loading = false;
  loadingMessage = '';

  @computed('loading', 'disabled')
  get disabledAttr() {
    return this.disabled || this.loading ? 'disabled' : null;
  }
}
